import React from "react";

const PODetails = ({
  isPOData,
  isLatestPONumber,
  setPOData,
  isViewMode,
  setErrors,
  isEditMode,
  errors,
}) => {
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth(); // Jan = 0, Apr = 3

    let startYear;
    let endYear;

    if (month >= 3) {
      // April to December
      startYear = year;
      endYear = year + 1;
    } else {
      // January to March
      startYear = year - 1;
      endYear = year;
    }

    return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
  };
  const handlePONameChange = (e) => {
    const value = e.target.value;

    setPOData((prev) => ({
      ...prev,
      poNumber: value,
    }));

    const financialYear = getCurrentFinancialYear();

    const poRegex = new RegExp(`^PO\\/${financialYear}\\/\\d{4}$`);

    if (value && !poRegex.test(value)) {
      setErrors((prev) => ({
        ...prev,
        poNumber: `PO Number must be in the format PO/${financialYear}/0001`,
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        poNumber: "",
      }));
    }
  };
  const handlePoDateChange = (e) => {
    setPOData((prev) => ({
      ...prev,
      poDate: e.target.value,
    }));
  };
  const handleDeliveryDate = (e) => {
    setPOData((prev) => ({
      ...prev,
      poDeliveryDate: e.target.value,
    }));
  };
  return (
    <div className=" px-6 py-2 bg-white max-w-[1400px]">
      <h2 className="mb-8 text-center text-2xl font-bold">PO Details</h2>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <div className="space-y-6">
          <div>
            <div className="flex justify-between">
              <p className=" text-[16px] text-[#000000] font-medium leading-6">
                PO Number:
              </p>

              {isViewMode || isEditMode ? (
                <span className=" text-[16px] text-[#000000]  leading-6">
                  {isPOData?.po_number}
                </span>
              ) : (
                <input
                  type="text"
                  className="rounded border p-2"
                  name="poNumber"
                  disabled={isViewMode}
                  value={isPOData?.poNumber || isLatestPONumber}
                  onChange={(e) => handlePONameChange(e)}
                />
              )}
            </div>
            {errors?.poNumber && (
              <p className="mt-1 text-xs text-red-500">{errors.poNumber}</p>
            )}
          </div>

          <div className="flex justify-between">
            <p className=" text-[16px] text-[#000000] font-medium leading-6">
              Delivery Date:
            </p>

            {isViewMode ? (
              <div>
                {isPOData?.delivery_date
                  ? new Date(isPOData.delivery_date).toLocaleDateString(
                      "en-IN",
                      {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      },
                    )
                  : "-"}
              </div>
            ) : (
              <input
                type="date"
                className="rounded border p-2"
                name="poDeliveryDate"
                value={
                  isPOData?.poDeliveryDate
                    ? new Date(isPOData.poDeliveryDate)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                min={new Date().toISOString().split("T")[0]}
                onChange={handleDeliveryDate}
                onKeyDown={(e) => e.preventDefault()} // Prevent typing
                onPaste={(e) => e.preventDefault()} // Prevent paste
              />
            )}
          </div>

          <div className="flex justify-between">
            <p className=" text-[16px] text-[#000000] font-medium leading-6">
              No of Items:
            </p>
            <span className=" text-[16px] text-[#000000]  leading-6">
              {isPOData?.no_of_items}
            </span>
          </div>

          <div className="flex justify-between">
            <p className=" text-[16px] text-[#000000] font-medium leading-6">
              Indent Number:
            </p>
            <span className=" text-[16px] text-[#000000]  leading-6">
              {isPOData?.indent_number || "N/A"}
            </span>
          </div>
        </div>

        <div className="space-y-6">
          <div className="flex justify-between">
            <p className=" text-[16px] text-[#000000] font-medium leading-6">
              PO Date:
            </p>

            {isViewMode || isEditMode ? (
              <div>
                {isPOData?.po_date
                  ? new Date(isPOData.po_date).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })
                  : "-"}
              </div>
            ) : (
              <div>
                {new Date().toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                })}
              </div>
            )}
          </div>

          <div className="flex justify-between">
            <p className=" text-[16px] text-[#000000] font-medium leading-6">
              PO Amendment:
            </p>
            <span className=" text-[16px] text-[#000000]  leading-6">
              {isPOData?.amendment || 0}
            </span>
          </div>

          <div className="flex justify-between">
            <p className=" text-[16px] text-[#000000] font-medium leading-6">
              PO Amount:
            </p>
            <span className=" text-[16px] text-[#000000]  leading-6">
              ₹ {isPOData?.total_after_tax_amount?.toFixed(2) || "0.00"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PODetails;
